import axios from "axios";
import { ActionContext, Module } from "vuex";

export interface IServiceFeature {
  code: string;
}

export interface IServiceDefinition {
  code: number;
  name: string;
  features: IServiceFeature[];
}

export class ServicesDefinitionState {
  public services: IServiceDefinition[];

  constructor() {
    this.services = [];
  }

  public withServices(data: any) {
    this.services = data.services;
  }
}

export default {
  namespaced: true,
  state: () => new ServicesDefinitionState(),
  mutations: {
    save(state: ServicesDefinitionState, data: any) {
      state.withServices(data);
    }
  },
  actions: {
    init(context: ActionContext<ServicesDefinitionState, any>): void {
      axios.get("/services-definition")
        .then((response) => {
          context.commit("save", response.data);
        });
    }
  }
} as Module<ServicesDefinitionState, any>;
